// Canvas factory so the same drawing code runs in the browser and on the
// server (@napi-rs/canvas, see server/render.ts).

export type AnyCanvas = HTMLCanvasElement;
export type Ctx2D = CanvasRenderingContext2D;

let factory: (w: number, h: number) => AnyCanvas = (w, h) => {
  const c = document.createElement('canvas');
  c.width = w;
  c.height = h;
  return c;
};

export function setCanvasFactory(f: (w: number, h: number) => unknown) {
  factory = f as (w: number, h: number) => AnyCanvas;
}

export function makeCanvas(w: number, h: number): AnyCanvas {
  return factory(Math.max(1, Math.round(w)), Math.max(1, Math.round(h)));
}
